import {
    Box,
    Stack,
    Dialog,
    IconButton,
    Button,
    Typography,
    Grid,
    alpha,
    styled,
} from '../../../base';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        width: 650,
        maxWidth: '95%',
        borderRadius: theme.spacing(2),
    },
}));

export const StyledHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2.5),
    backgroundColor: alpha(theme.palette.grey[500], 0.07),
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
    flex: 1,
    fontWeight: 700,
    color: theme.palette.text.primary,
}));

export const StyledCloseButton = styled(IconButton)(() => ({
    flexShrink: 0,
}));

export const StyledSubjectRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2.5),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));

export const StyledSubjectLabel = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'error',
})<{ error?: boolean }>(({ theme, error }) => ({
    flexShrink: 0,
    fontSize: 14,
    color: error ? theme.palette.error.main : theme.palette.text.secondary,
}));

export const StyledEditorWrapper = styled(Box)(({theme}) => ({
    padding: 0,
    '& .ql-editor': {
        height: 400,
    },
    '& .ql-toolbar.ql-snow': {
        border: 'none',
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    '& .ql-container.ql-snow': {
        border: 'none',
    },
}));

export const StyledPreviewFooter = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: theme.spacing(0, 0, 2, 2),
}));

export const StyledPargodaLogo = styled('img')({
    height: 24,
    width: 'auto',
});

export const StyledActions = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.5),
}));

export const StyledDraftButton = styled(Button)(({ theme }) => ({
    borderRadius: theme.spacing(3),
    paddingInline: theme.spacing(3),
    textTransform: 'none',
    fontWeight: 700,
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
}));

export const StyledPublishButton = styled(Button)(({ theme }) => ({
    borderRadius: theme.spacing(3),
    paddingInline: theme.spacing(3),
    textTransform: 'none',
    fontWeight: 700,
    color: theme.palette.common.white,
    background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
    '&:hover': {
        background: `linear-gradient(180deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    },
    '&.Mui-disabled': {
        color: theme.palette.common.white,
        opacity: 0.6,
    },
}));

export const StyledNameField = styled(Box)(({ theme }) => ({
    flex: 1,
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiOutlinedInput-root': { padding: 0, height: 'auto' },
    '& .MuiOutlinedInput-input': {
        padding: '4px 0',
        fontSize: 16,
        fontWeight: 700,
    },
    '& .MuiFormHelperText-root': { display: 'none' },
    '& .Mui-error input::placeholder': {
        color: theme.palette.error.main,
        opacity: 1,
    },
}));

export const StyledSubjectField = styled(Box)({
    flex: 1,
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiOutlinedInput-root': { padding: 0, height: 'auto' },
    '& .MuiOutlinedInput-input': {
        padding: '4px 0',
        fontSize: 14,
        lineHeight: 1.42,
    },
    '& .MuiFormHelperText-root': { display: 'none' },
});
